var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyticsChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.33196 2 4.97501V20.0064C2 20.9438 3.19036 21.3578 3.78087 20.6259L6 17.975H19C20.6569 17.975 22 16.6431 22 15V4.97501C22 3.33196 20.6569 2 19 2H5ZM6.25 13C6.25 12.5858 6.58579 12.25 7 12.25H17C17.4142 12.25 17.75 12.5858 17.75 13C17.75 13.4142 17.4142 13.75 17 13.75H7C6.58579 13.75 6.25 13.4142 6.25 13ZM8.75 9V10C8.75 10.4142 8.41421 10.75 8 10.75C7.58579 10.75 7.25 10.4142 7.25 10V9C7.25 8.58579 7.58579 8.25 8 8.25C8.41421 8.25 8.75 8.58579 8.75 9ZM12 6.25C12.4142 6.25 12.75 6.58579 12.75 7V10C12.75 10.4142 12.4142 10.75 12 10.75C11.5858 10.75 11.25 10.4142 11.25 10V7C11.25 6.58579 11.5858 6.25 12 6.25ZM16.75 5V10C16.75 10.4142 16.4142 10.75 16 10.75C15.5858 10.75 15.25 10.4142 15.25 10V5C15.25 4.58579 15.5858 4.25 16 4.25C16.4142 4.25 16.75 4.58579 16.75 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyticsChat);
export default __webpack_public_path__ + "static/media/analytics-chat.bc6a90b4882f1a5711423d14e2b40a03.svg";
export { ForwardRef as ReactComponent };